import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\AuthController::login
 * @see app/Http/Controllers/AuthController.php:195
 * @route '/login'
 */
export const login = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: login.url(options),
    method: 'post',
})

login.definition = {
    methods: ["post"],
    url: '/login',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AuthController::login
 * @see app/Http/Controllers/AuthController.php:195
 * @route '/login'
 */
login.url = (options?: RouteQueryOptions) => {
    return login.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthController::login
 * @see app/Http/Controllers/AuthController.php:195
 * @route '/login'
 */
login.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: login.url(options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\AuthController::login
 * @see app/Http/Controllers/AuthController.php:195
 * @route '/login'
 */
    const loginForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: login.url(options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\AuthController::login
 * @see app/Http/Controllers/AuthController.php:195
 * @route '/login'
 */
        loginForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: login.url(options),
            method: 'post',
        })
    
    login.form = loginForm
/**
* @see \App\Http\Controllers\AuthController::helpUsername
 * @see app/Http/Controllers/AuthController.php:374
 * @route '/login/help/username'
 */
export const helpUsername = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: helpUsername.url(options),
    method: 'post',
})

helpUsername.definition = {
    methods: ["post"],
    url: '/login/help/username',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AuthController::helpUsername
 * @see app/Http/Controllers/AuthController.php:374
 * @route '/login/help/username'
 */
helpUsername.url = (options?: RouteQueryOptions) => {
    return helpUsername.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthController::helpUsername
 * @see app/Http/Controllers/AuthController.php:374
 * @route '/login/help/username'
 */
helpUsername.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: helpUsername.url(options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\AuthController::helpUsername
 * @see app/Http/Controllers/AuthController.php:374
 * @route '/login/help/username'
 */
    const helpUsernameForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: helpUsername.url(options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\AuthController::helpUsername
 * @see app/Http/Controllers/AuthController.php:374
 * @route '/login/help/username'
 */
        helpUsernameForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: helpUsername.url(options),
            method: 'post',
        })
    
    helpUsername.form = helpUsernameForm
/**
* @see \App\Http\Controllers\AuthController::logout
 * @see app/Http/Controllers/AuthController.php:323
 * @route '/logout'
 */
export const logout = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

logout.definition = {
    methods: ["post"],
    url: '/logout',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AuthController::logout
 * @see app/Http/Controllers/AuthController.php:323
 * @route '/logout'
 */
logout.url = (options?: RouteQueryOptions) => {
    return logout.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthController::logout
 * @see app/Http/Controllers/AuthController.php:323
 * @route '/logout'
 */
logout.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\AuthController::logout
 * @see app/Http/Controllers/AuthController.php:323
 * @route '/logout'
 */
    const logoutForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: logout.url(options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\AuthController::logout
 * @see app/Http/Controllers/AuthController.php:323
 * @route '/logout'
 */
        logoutForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: logout.url(options),
            method: 'post',
        })
    
    logout.form = logoutForm
/**
* @see \App\Http\Controllers\AuthController::forgetDevice
 * @see app/Http/Controllers/AuthController.php:357
 * @route '/forget-device'
 */
export const forgetDevice = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: forgetDevice.url(options),
    method: 'post',
})

forgetDevice.definition = {
    methods: ["post"],
    url: '/forget-device',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AuthController::forgetDevice
 * @see app/Http/Controllers/AuthController.php:357
 * @route '/forget-device'
 */
forgetDevice.url = (options?: RouteQueryOptions) => {
    return forgetDevice.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthController::forgetDevice
 * @see app/Http/Controllers/AuthController.php:357
 * @route '/forget-device'
 */
forgetDevice.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: forgetDevice.url(options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\AuthController::forgetDevice
 * @see app/Http/Controllers/AuthController.php:357
 * @route '/forget-device'
 */
    const forgetDeviceForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: forgetDevice.url(options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\AuthController::forgetDevice
 * @see app/Http/Controllers/AuthController.php:357
 * @route '/forget-device'
 */
        forgetDeviceForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: forgetDevice.url(options),
            method: 'post',
        })
    
    forgetDevice.form = forgetDeviceForm
/**
* @see \App\Http\Controllers\AuthController::reauthenticateNotice
 * @see app/Http/Controllers/AuthController.php:884
 * @route '/reauthenticate'
 */
export const reauthenticateNotice = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: reauthenticateNotice.url(options),
    method: 'get',
})

reauthenticateNotice.definition = {
    methods: ["get","head"],
    url: '/reauthenticate',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AuthController::reauthenticateNotice
 * @see app/Http/Controllers/AuthController.php:884
 * @route '/reauthenticate'
 */
reauthenticateNotice.url = (options?: RouteQueryOptions) => {
    return reauthenticateNotice.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthController::reauthenticateNotice
 * @see app/Http/Controllers/AuthController.php:884
 * @route '/reauthenticate'
 */
reauthenticateNotice.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: reauthenticateNotice.url(options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\AuthController::reauthenticateNotice
 * @see app/Http/Controllers/AuthController.php:884
 * @route '/reauthenticate'
 */
reauthenticateNotice.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: reauthenticateNotice.url(options),
    method: 'head',
})

    /**
* @see \App\Http\Controllers\AuthController::reauthenticateNotice
 * @see app/Http/Controllers/AuthController.php:884
 * @route '/reauthenticate'
 */
    const reauthenticateNoticeForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
        action: reauthenticateNotice.url(options),
        method: 'get',
    })

            /**
* @see \App\Http\Controllers\AuthController::reauthenticateNotice
 * @see app/Http/Controllers/AuthController.php:884
 * @route '/reauthenticate'
 */
        reauthenticateNoticeForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: reauthenticateNotice.url(options),
            method: 'get',
        })
            /**
* @see \App\Http\Controllers\AuthController::reauthenticateNotice
 * @see app/Http/Controllers/AuthController.php:884
 * @route '/reauthenticate'
 */
        reauthenticateNoticeForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: reauthenticateNotice.url({
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'HEAD',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'get',
        })
    
    reauthenticateNotice.form = reauthenticateNoticeForm
/**
* @see \App\Http\Controllers\AuthController::reauthenticate
 * @see app/Http/Controllers/AuthController.php:839
 * @route '/reauthenticate'
 */
export const reauthenticate = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: reauthenticate.url(options),
    method: 'post',
})

reauthenticate.definition = {
    methods: ["post"],
    url: '/reauthenticate',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AuthController::reauthenticate
 * @see app/Http/Controllers/AuthController.php:839
 * @route '/reauthenticate'
 */
reauthenticate.url = (options?: RouteQueryOptions) => {
    return reauthenticate.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthController::reauthenticate
 * @see app/Http/Controllers/AuthController.php:839
 * @route '/reauthenticate'
 */
reauthenticate.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: reauthenticate.url(options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\AuthController::reauthenticate
 * @see app/Http/Controllers/AuthController.php:839
 * @route '/reauthenticate'
 */
    const reauthenticateForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: reauthenticate.url(options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\AuthController::reauthenticate
 * @see app/Http/Controllers/AuthController.php:839
 * @route '/reauthenticate'
 */
        reauthenticateForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: reauthenticate.url(options),
            method: 'post',
        })
    
    reauthenticate.form = reauthenticateForm
/**
* @see \App\Http\Controllers\AuthController::reauthenticateMethods
 * @see app/Http/Controllers/AuthController.php:714
 * @route '/reauthenticate/methods'
 */
export const reauthenticateMethods = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: reauthenticateMethods.url(options),
    method: 'get',
})

reauthenticateMethods.definition = {
    methods: ["get","head"],
    url: '/reauthenticate/methods',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AuthController::reauthenticateMethods
 * @see app/Http/Controllers/AuthController.php:714
 * @route '/reauthenticate/methods'
 */
reauthenticateMethods.url = (options?: RouteQueryOptions) => {
    return reauthenticateMethods.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthController::reauthenticateMethods
 * @see app/Http/Controllers/AuthController.php:714
 * @route '/reauthenticate/methods'
 */
reauthenticateMethods.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: reauthenticateMethods.url(options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\AuthController::reauthenticateMethods
 * @see app/Http/Controllers/AuthController.php:714
 * @route '/reauthenticate/methods'
 */
reauthenticateMethods.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: reauthenticateMethods.url(options),
    method: 'head',
})

    /**
* @see \App\Http\Controllers\AuthController::reauthenticateMethods
 * @see app/Http/Controllers/AuthController.php:714
 * @route '/reauthenticate/methods'
 */
    const reauthenticateMethodsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
        action: reauthenticateMethods.url(options),
        method: 'get',
    })

            /**
* @see \App\Http\Controllers\AuthController::reauthenticateMethods
 * @see app/Http/Controllers/AuthController.php:714
 * @route '/reauthenticate/methods'
 */
        reauthenticateMethodsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: reauthenticateMethods.url(options),
            method: 'get',
        })
            /**
* @see \App\Http\Controllers\AuthController::reauthenticateMethods
 * @see app/Http/Controllers/AuthController.php:714
 * @route '/reauthenticate/methods'
 */
        reauthenticateMethodsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: reauthenticateMethods.url({
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'HEAD',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'get',
        })
    
    reauthenticateMethods.form = reauthenticateMethodsForm
/**
* @see \App\Http\Controllers\AuthController::reauthenticateRequestCode
 * @see app/Http/Controllers/AuthController.php:742
 * @route '/reauthenticate/{method}/code'
 */
export const reauthenticateRequestCode = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: reauthenticateRequestCode.url(args, options),
    method: 'get',
})

reauthenticateRequestCode.definition = {
    methods: ["get","head"],
    url: '/reauthenticate/{method}/code',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AuthController::reauthenticateRequestCode
 * @see app/Http/Controllers/AuthController.php:742
 * @route '/reauthenticate/{method}/code'
 */
reauthenticateRequestCode.url = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { method: args }
    }

    
    if (Array.isArray(args)) {
        args = {
                    method: args[0],
                }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
                        method: args.method,
                }

    return reauthenticateRequestCode.definition.url
            .replace('{method}', parsedArgs.method.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthController::reauthenticateRequestCode
 * @see app/Http/Controllers/AuthController.php:742
 * @route '/reauthenticate/{method}/code'
 */
reauthenticateRequestCode.get = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: reauthenticateRequestCode.url(args, options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\AuthController::reauthenticateRequestCode
 * @see app/Http/Controllers/AuthController.php:742
 * @route '/reauthenticate/{method}/code'
 */
reauthenticateRequestCode.head = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: reauthenticateRequestCode.url(args, options),
    method: 'head',
})

    /**
* @see \App\Http\Controllers\AuthController::reauthenticateRequestCode
 * @see app/Http/Controllers/AuthController.php:742
 * @route '/reauthenticate/{method}/code'
 */
    const reauthenticateRequestCodeForm = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
        action: reauthenticateRequestCode.url(args, options),
        method: 'get',
    })

            /**
* @see \App\Http\Controllers\AuthController::reauthenticateRequestCode
 * @see app/Http/Controllers/AuthController.php:742
 * @route '/reauthenticate/{method}/code'
 */
        reauthenticateRequestCodeForm.get = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: reauthenticateRequestCode.url(args, options),
            method: 'get',
        })
            /**
* @see \App\Http\Controllers\AuthController::reauthenticateRequestCode
 * @see app/Http/Controllers/AuthController.php:742
 * @route '/reauthenticate/{method}/code'
 */
        reauthenticateRequestCodeForm.head = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: reauthenticateRequestCode.url(args, {
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'HEAD',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'get',
        })
    
    reauthenticateRequestCode.form = reauthenticateRequestCodeForm
/**
* @see \App\Http\Controllers\AuthController::reauthenticateVerifyCode
 * @see app/Http/Controllers/AuthController.php:804
 * @route '/reauthenticate/{method}/code'
 */
export const reauthenticateVerifyCode = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: reauthenticateVerifyCode.url(args, options),
    method: 'post',
})

reauthenticateVerifyCode.definition = {
    methods: ["post"],
    url: '/reauthenticate/{method}/code',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AuthController::reauthenticateVerifyCode
 * @see app/Http/Controllers/AuthController.php:804
 * @route '/reauthenticate/{method}/code'
 */
reauthenticateVerifyCode.url = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { method: args }
    }

    
    if (Array.isArray(args)) {
        args = {
                    method: args[0],
                }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
                        method: args.method,
                }

    return reauthenticateVerifyCode.definition.url
            .replace('{method}', parsedArgs.method.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthController::reauthenticateVerifyCode
 * @see app/Http/Controllers/AuthController.php:804
 * @route '/reauthenticate/{method}/code'
 */
reauthenticateVerifyCode.post = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: reauthenticateVerifyCode.url(args, options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\AuthController::reauthenticateVerifyCode
 * @see app/Http/Controllers/AuthController.php:804
 * @route '/reauthenticate/{method}/code'
 */
    const reauthenticateVerifyCodeForm = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: reauthenticateVerifyCode.url(args, options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\AuthController::reauthenticateVerifyCode
 * @see app/Http/Controllers/AuthController.php:804
 * @route '/reauthenticate/{method}/code'
 */
        reauthenticateVerifyCodeForm.post = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: reauthenticateVerifyCode.url(args, options),
            method: 'post',
        })
    
    reauthenticateVerifyCode.form = reauthenticateVerifyCodeForm
/**
* @see \App\Http\Controllers\AuthController::getTwoFactorMethods
 * @see app/Http/Controllers/AuthController.php:401
 * @route '/login/two-factor/auth'
 */
export const getTwoFactorMethods = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: getTwoFactorMethods.url(options),
    method: 'get',
})

getTwoFactorMethods.definition = {
    methods: ["get","head"],
    url: '/login/two-factor/auth',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AuthController::getTwoFactorMethods
 * @see app/Http/Controllers/AuthController.php:401
 * @route '/login/two-factor/auth'
 */
getTwoFactorMethods.url = (options?: RouteQueryOptions) => {
    return getTwoFactorMethods.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthController::getTwoFactorMethods
 * @see app/Http/Controllers/AuthController.php:401
 * @route '/login/two-factor/auth'
 */
getTwoFactorMethods.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: getTwoFactorMethods.url(options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\AuthController::getTwoFactorMethods
 * @see app/Http/Controllers/AuthController.php:401
 * @route '/login/two-factor/auth'
 */
getTwoFactorMethods.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: getTwoFactorMethods.url(options),
    method: 'head',
})

    /**
* @see \App\Http\Controllers\AuthController::getTwoFactorMethods
 * @see app/Http/Controllers/AuthController.php:401
 * @route '/login/two-factor/auth'
 */
    const getTwoFactorMethodsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
        action: getTwoFactorMethods.url(options),
        method: 'get',
    })

            /**
* @see \App\Http\Controllers\AuthController::getTwoFactorMethods
 * @see app/Http/Controllers/AuthController.php:401
 * @route '/login/two-factor/auth'
 */
        getTwoFactorMethodsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: getTwoFactorMethods.url(options),
            method: 'get',
        })
            /**
* @see \App\Http\Controllers\AuthController::getTwoFactorMethods
 * @see app/Http/Controllers/AuthController.php:401
 * @route '/login/two-factor/auth'
 */
        getTwoFactorMethodsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: getTwoFactorMethods.url({
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'HEAD',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'get',
        })
    
    getTwoFactorMethods.form = getTwoFactorMethodsForm
/**
* @see \App\Http\Controllers\AuthController::verifyRecoveryCode
 * @see app/Http/Controllers/AuthController.php:627
 * @route '/login/two-factor/recovery'
 */
export const verifyRecoveryCode = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: verifyRecoveryCode.url(options),
    method: 'post',
})

verifyRecoveryCode.definition = {
    methods: ["post"],
    url: '/login/two-factor/recovery',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AuthController::verifyRecoveryCode
 * @see app/Http/Controllers/AuthController.php:627
 * @route '/login/two-factor/recovery'
 */
verifyRecoveryCode.url = (options?: RouteQueryOptions) => {
    return verifyRecoveryCode.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthController::verifyRecoveryCode
 * @see app/Http/Controllers/AuthController.php:627
 * @route '/login/two-factor/recovery'
 */
verifyRecoveryCode.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: verifyRecoveryCode.url(options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\AuthController::verifyRecoveryCode
 * @see app/Http/Controllers/AuthController.php:627
 * @route '/login/two-factor/recovery'
 */
    const verifyRecoveryCodeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: verifyRecoveryCode.url(options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\AuthController::verifyRecoveryCode
 * @see app/Http/Controllers/AuthController.php:627
 * @route '/login/two-factor/recovery'
 */
        verifyRecoveryCodeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: verifyRecoveryCode.url(options),
            method: 'post',
        })
    
    verifyRecoveryCode.form = verifyRecoveryCodeForm
/**
* @see \App\Http\Controllers\AuthController::requestTwoFactorCode
 * @see app/Http/Controllers/AuthController.php:442
 * @route '/login/two-factor/{method}/code'
 */
export const requestTwoFactorCode = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: requestTwoFactorCode.url(args, options),
    method: 'get',
})

requestTwoFactorCode.definition = {
    methods: ["get","head"],
    url: '/login/two-factor/{method}/code',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AuthController::requestTwoFactorCode
 * @see app/Http/Controllers/AuthController.php:442
 * @route '/login/two-factor/{method}/code'
 */
requestTwoFactorCode.url = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { method: args }
    }

    
    if (Array.isArray(args)) {
        args = {
                    method: args[0],
                }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
                        method: args.method,
                }

    return requestTwoFactorCode.definition.url
            .replace('{method}', parsedArgs.method.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthController::requestTwoFactorCode
 * @see app/Http/Controllers/AuthController.php:442
 * @route '/login/two-factor/{method}/code'
 */
requestTwoFactorCode.get = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: requestTwoFactorCode.url(args, options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\AuthController::requestTwoFactorCode
 * @see app/Http/Controllers/AuthController.php:442
 * @route '/login/two-factor/{method}/code'
 */
requestTwoFactorCode.head = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: requestTwoFactorCode.url(args, options),
    method: 'head',
})

    /**
* @see \App\Http\Controllers\AuthController::requestTwoFactorCode
 * @see app/Http/Controllers/AuthController.php:442
 * @route '/login/two-factor/{method}/code'
 */
    const requestTwoFactorCodeForm = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
        action: requestTwoFactorCode.url(args, options),
        method: 'get',
    })

            /**
* @see \App\Http\Controllers\AuthController::requestTwoFactorCode
 * @see app/Http/Controllers/AuthController.php:442
 * @route '/login/two-factor/{method}/code'
 */
        requestTwoFactorCodeForm.get = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: requestTwoFactorCode.url(args, options),
            method: 'get',
        })
            /**
* @see \App\Http\Controllers\AuthController::requestTwoFactorCode
 * @see app/Http/Controllers/AuthController.php:442
 * @route '/login/two-factor/{method}/code'
 */
        requestTwoFactorCodeForm.head = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: requestTwoFactorCode.url(args, {
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'HEAD',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'get',
        })
    
    requestTwoFactorCode.form = requestTwoFactorCodeForm
/**
* @see \App\Http\Controllers\AuthController::verifyTwoFactorCode
 * @see app/Http/Controllers/AuthController.php:550
 * @route '/login/two-factor/{method}/code'
 */
export const verifyTwoFactorCode = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: verifyTwoFactorCode.url(args, options),
    method: 'post',
})

verifyTwoFactorCode.definition = {
    methods: ["post"],
    url: '/login/two-factor/{method}/code',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AuthController::verifyTwoFactorCode
 * @see app/Http/Controllers/AuthController.php:550
 * @route '/login/two-factor/{method}/code'
 */
verifyTwoFactorCode.url = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { method: args }
    }

    
    if (Array.isArray(args)) {
        args = {
                    method: args[0],
                }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
                        method: args.method,
                }

    return verifyTwoFactorCode.definition.url
            .replace('{method}', parsedArgs.method.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthController::verifyTwoFactorCode
 * @see app/Http/Controllers/AuthController.php:550
 * @route '/login/two-factor/{method}/code'
 */
verifyTwoFactorCode.post = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: verifyTwoFactorCode.url(args, options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\AuthController::verifyTwoFactorCode
 * @see app/Http/Controllers/AuthController.php:550
 * @route '/login/two-factor/{method}/code'
 */
    const verifyTwoFactorCodeForm = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: verifyTwoFactorCode.url(args, options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\AuthController::verifyTwoFactorCode
 * @see app/Http/Controllers/AuthController.php:550
 * @route '/login/two-factor/{method}/code'
 */
        verifyTwoFactorCodeForm.post = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: verifyTwoFactorCode.url(args, options),
            method: 'post',
        })
    
    verifyTwoFactorCode.form = verifyTwoFactorCodeForm
const AuthController = { login, helpUsername, logout, forgetDevice, reauthenticateNotice, reauthenticate, reauthenticateMethods, reauthenticateRequestCode, reauthenticateVerifyCode, getTwoFactorMethods, verifyRecoveryCode, requestTwoFactorCode, verifyTwoFactorCode }

export default AuthController